import Api from '@/services/Api'
import { ToastProgrammatic as Toast } from 'buefy'

const entity = '/proposta'

export default {

    Index(cargo, cargoId, page, numero, titulo, grade) {

        var cargoRoute = cargo == "admin" || cargo == "corretor" ? "" : (
            cargo == "aluno"    ? "/alunoindex/"    : (
            cargo == "diretor"  ? "/diretorindex/"  :  
            '' )) + cargoId;

        numero = numero == undefined ? "" : numero
        titulo = titulo == undefined ? "" : titulo
        grade  = grade  == undefined ? "" : grade
        
        return Api().get(
            `${entity}${cargoRoute}?page=${page}&numero=${numero}&titulo=${titulo}&grade=${grade}`
        ).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    PerGrade(cargo, cargoId){
        cargo;
        return Api().get(
            `${entity}/pergrade/${cargoId}`
        ).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },
    
    Info(uuid) {
        return Api().get(`${entity}/${uuid}`).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    Create(params) {
        let api = Api()
        api.defaults.headers['Content-Type'] = 'multipart/form-data'
        let formData = new FormData()
        formData.append('file', params.file)
        formData.append('nome', params.nome)
        formData.append('numero', params.numero)
        formData.append('grade_id', params.grade_id)
        formData.append('videos', JSON.stringify(params.videos))
        formData.append('escolas', JSON.stringify(params.escolas))
        
        return api.post(`${entity}`, formData).then(response => { 
            api.defaults.headers['Content-Type'] = 'application/json' 
            return response.data
        },
            
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },


    Update(uuid,params) {
        return Api().put(`${entity}/${uuid}`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    Delete(uuid) {
        return Api().delete(`${entity}/${uuid}`).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },


}
